// Assets/custom-header.js

document.addEventListener('DOMContentLoaded', () => {
  const menuToggle = document.getElementById('sageMenuToggle');
  const menuClose = document.getElementById('sageMenuClose');
  const overlay = document.getElementById('sageOverlay');
  const drawer = document.getElementById('sageDrawer');
  
  // 1. Toggle Drawer Principale - SISTEMA TRANSFORM
  function toggleMenu(isOpen) {
    if(isOpen) {
      drawer.classList.add('is-open');
      overlay.classList.add('is-open');
      document.body.style.overflow = 'hidden';
    } else {
      drawer.classList.remove('is-open');
      overlay.classList.remove('is-open');
      document.body.style.overflow = '';
    }
  }

  if(menuToggle) menuToggle.addEventListener('click', () => toggleMenu(true));
  if(menuClose) menuClose.addEventListener('click', () => toggleMenu(false));
  if(overlay) overlay.addEventListener('click', () => toggleMenu(false));

  // 2. Toggle Livello 2 (es. Categorie -> Raccorderia)
  const submenuToggles = document.querySelectorAll('.toggle-submenu');
  submenuToggles.forEach(btn => {
    btn.addEventListener('click', (e) => {
      e.preventDefault();
      const parent = btn.closest('.drawer-item');
      parent.classList.toggle('submenu-open');
      // L'icona viene ruotata via CSS
    });
  });

  // 3. Toggle Livello 3 (es. Raccorderia -> Tubi)
  const grandmenuToggles = document.querySelectorAll('.toggle-grandmenu');
  grandmenuToggles.forEach(btn => {
    btn.addEventListener('click', (e) => {
      e.preventDefault();
      // Previene la chiusura del genitore se clicchi il bottone
      e.stopPropagation(); 
      const parent = btn.closest('.drawer-subitem');
      parent.classList.toggle('grandmenu-open');
    });
  });

  // 4. Ricerca Live (Predictive)
  const searchInput = document.getElementById('SageSearchInput');
  const resultsContainer = document.getElementById('SagePredictiveResults');
  const searchForm = document.querySelector('.sage-search-form');
  let searchTimeout;

  if (searchInput) {
    searchInput.addEventListener('input', function() {
      const query = this.value.trim();
      clearTimeout(searchTimeout);
      if (query.length === 0) { closeResults(); return; }
      searchTimeout = setTimeout(() => fetchPredictiveResults(query), 300);
    });

    document.addEventListener('click', (e) => {
      if (!searchForm.contains(e.target)) closeResults();
    });
  }

  function fetchPredictiveResults(query) {
    fetch(`/search/suggest.json?q=${query}&resources[type]=product&resources[limit]=5`)
      .then(response => response.json())
      .then(data => {
        const products = data.resources.results.products;
        if (products && products.length > 0) {
          renderResults(products, query);
        } else {
          closeResults();
        }
      })
      .catch(error => console.error(error));
  }

  function renderResults(products, query) {
    searchForm.classList.add('is-active');
    resultsContainer.classList.add('has-results');
    
    let html = '';
    products.forEach(p => {
      const img = p.image || '//cdn.shopify.com/s/files/1/0533/2089/files/placeholder-images-image_large.png';
      html += `
        <a href="${p.url}" class="search-result-item">
          <img src="${img}" class="result-image">
          <div class="result-info">
            <span class="result-title">${p.title}</span>
            <span class="result-price">${p.price}</span>
          </div>
        </a>
      `;
    });
    html += `<a href="/search?q=${query}" class="view-all-link">Vedi tutti per "${query}"</a>`;
    resultsContainer.innerHTML = html;
  }

  function closeResults() {
    searchForm.classList.remove('is-active');
    resultsContainer.classList.remove('has-results');
    resultsContainer.innerHTML = '';
  }

  // 5. Ricerca Mobile
  const mobileSearchToggle = document.querySelector('.mobile-search-toggle');
  const mobileSearchOverlay = document.getElementById('mobileSearchOverlay');
  const closeMobileSearch = document.querySelector('.close-mobile-search');
  const sageSearchInputMobile = document.getElementById('SageSearchInputMobile');
  const sagePredictiveResultsMobile = document.getElementById('SagePredictiveResultsMobile');

  if (mobileSearchToggle) {
    mobileSearchToggle.addEventListener('click', () => {
      mobileSearchOverlay.classList.add('is-open');
      document.body.style.overflow = 'hidden';
      if (sageSearchInputMobile) {
        setTimeout(() => sageSearchInputMobile.focus(), 100);
      }
    });
  }

  if (closeMobileSearch) {
    closeMobileSearch.addEventListener('click', () => {
      mobileSearchOverlay.classList.remove('is-open');
      document.body.style.overflow = '';
    });
  }

  if (mobileSearchOverlay) {
    mobileSearchOverlay.addEventListener('click', (e) => {
      if (e.target === mobileSearchOverlay) {
        mobileSearchOverlay.classList.remove('is-open');
        document.body.style.overflow = '';
      }
    });
  }

  // Predictive search per mobile
  if (sageSearchInputMobile) {
    let mobileSearchTimeout;
    
    sageSearchInputMobile.addEventListener('input', function() {
      const query = this.value.trim();
      clearTimeout(mobileSearchTimeout);
      if (query.length === 0) {
        closeMobileResults();
        return;
      }
      mobileSearchTimeout = setTimeout(() => fetchPredictiveResultsMobile(query), 300);
    });

    sageSearchInputMobile.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') {
        closeMobileResults();
        sageSearchInputMobile.blur();
      }
    });
  }

  function fetchPredictiveResultsMobile(query) {
    fetch(`/search/suggest.json?q=${query}&resources[type]=product&resources[limit]=5`)
      .then(response => response.json())
      .then(data => {
        const products = data.resources.results.products;
        if (products && products.length > 0) {
          renderMobileResults(products, query);
        } else {
          closeMobileResults();
        }
      })
      .catch(error => console.error(error));
  }

  function renderMobileResults(products, query) {
    sagePredictiveResultsMobile.classList.add('has-results');
    
    let html = '';
    products.forEach(p => {
      const img = p.image || '//cdn.shopify.com/s/files/1/0533/2089/files/placeholder-images-image_large.png';
      html += `
        <a href="${p.url}" class="search-result-item">
          <img src="${img}" class="result-image">
          <div class="result-info">
            <span class="result-title">${p.title}</span>
            <span class="result-price">${p.price}</span>
          </div>
        </a>
      `;
    });
    html += `<a href="/search?q=${encodeURIComponent(query)}" class="view-all-link">Vedi tutti per "${query}"</a>`;
    sagePredictiveResultsMobile.innerHTML = html;
  }

  function closeMobileResults() {
    sagePredictiveResultsMobile.classList.remove('has-results');
    sagePredictiveResultsMobile.innerHTML = '';
  }

  // =========================================
  // 6. AGGIORNAMENTO DINAMICO CARRELLO - SISTEMA MIGLIORATO
  // =========================================

  // Funzione per aggiornare il contatore del carrello
  function updateCartCount() {
    fetch('/cart.js')
      .then(response => response.json())
      .then(cart => {
        const cartCount = cart.item_count;
        const cartCountElements = document.querySelectorAll('.cart-count');
        
        // Se non ci sono elementi cart-count, li creiamo
        if (cartCountElements.length === 0) {
          createCartBadges(cartCount);
        } else {
          cartCountElements.forEach(element => {
            updateCartBadge(element, cartCount);
          });
        }
      })
      .catch(error => console.error('Errore nel caricamento del carrello:', error));
  }

  // Funzione per creare i badge del carrello se non esistono
  function createCartBadges(count) {
    const cartLinks = document.querySelectorAll('a[href*="/cart"], .cart-link, .icon-link[href*="/cart"]');
    
    cartLinks.forEach(link => {
      // Verifica se esiste già un badge
      if (!link.querySelector('.cart-count')) {
        const badge = document.createElement('span');
        badge.className = 'cart-count';
        updateCartBadge(badge, count);
        link.appendChild(badge);
      }
    });
  }

  // Funzione per aggiornare un singolo badge
  function updateCartBadge(element, count) {
    if (count > 0) {
      element.textContent = count;
      element.style.display = 'flex';
      element.style.opacity = '1';
      element.style.transform = 'translateY(-50%) scale(1)';
      
      // Aggiungi classe per numeri alti (due cifre)
      if (count > 9) {
        element.classList.add('high-count');
      } else {
        element.classList.remove('high-count');
      }
    } else {
      element.textContent = '';
      element.style.display = 'none';
      element.style.opacity = '0';
      element.style.transform = 'translateY(-50%) scale(0)';
      element.classList.remove('high-count');
    }
  }

  // Aggiorna il contatore al caricamento della pagina
  updateCartCount();

  // Sistema di eventi per aggiornamento carrello
  function setupCartListeners() {
    // 1. Ascolta l'evento standard di Shopify per aggiornamenti AJAX
    document.addEventListener('ajaxCart.afterCartUpdate', function(event) {
      console.log('Evento ajaxCart.afterCartUpdate catturato');
      updateCartCount();
    });
    
    // 2. Ascolta l'evento personalizzato di Shopify (per temi moderni)
    document.addEventListener('cart:updated', function(event) {
      console.log('Evento cart:updated catturato');
      updateCartCount();
    });
    
    // 3. Intercetta i click sui pulsanti "Aggiungi al carrello"
    document.body.addEventListener('click', function(event) {
      const addToCartButton = event.target.closest('[name="add"], .add-to-cart, .product-form__submit, .add-to-cart-btn, .btn-addtocart');
      
      if (addToCartButton) {
        console.log('Pulsante aggiungi al carrello cliccato');
        
        // Aggiorna immediatamente con una piccola animazione
        setTimeout(() => {
          updateCartCount();
          
          // Aggiungi un'animazione di "pop" al badge
          const cartBadges = document.querySelectorAll('.cart-count');
          cartBadges.forEach(badge => {
            if (badge.textContent && badge.textContent !== '0') {
              badge.style.transform = 'translateY(-50%) scale(1.2)';
              setTimeout(() => {
                badge.style.transform = 'translateY(-50%) scale(1)';
              }, 200);
            }
          });
        }, 300);
        
        // Controllo aggiuntivo dopo 1.5 secondi
        setTimeout(updateCartCount, 1500);
      }
    });
    
    // 4. Intercetta i form di aggiunta al carrello
    const forms = document.querySelectorAll('form[action*="/cart/add"]');
    forms.forEach(form => {
      form.addEventListener('submit', function() {
        console.log('Form aggiungi al carrello inviato');
        setTimeout(updateCartCount, 800);
      });
    });
    
    // 5. Aggiorna quando la finestra riprende il focus
    window.addEventListener('focus', updateCartCount);
    
    // 6. Aggiornamento periodico (solo per sicurezza)
    setInterval(updateCartCount, 5000);
    
    // 7. Aggiornamento per Shopify Sections
    if (typeof Shopify !== 'undefined') {
      document.addEventListener('shopify:section:load', updateCartCount);
      document.addEventListener('shopify:section:unload', updateCartCount);
      document.addEventListener('shopify:section:select', updateCartCount);
      document.addEventListener('shopify:section:deselect', updateCartCount);
    }
    
    // 8. Observer per rilevare cambiamenti nel DOM (backup avanzato)
    const observer = new MutationObserver(function(mutations) {
      let shouldUpdate = false;
      
      mutations.forEach(function(mutation) {
        // Controlla se sono stati aggiunti elementi che potrebbero essere pulsanti carrello
        if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
          mutation.addedNodes.forEach(node => {
            if (node.nodeType === 1) { // Element node
              if (node.matches && (
                node.matches('[name="add"], .add-to-cart, .product-form__submit') ||
                node.querySelector('[name="add"], .add-to-cart, .product-form__submit')
              )) {
                shouldUpdate = true;
              }
            }
          });
        }
        
        // Controlla cambiamenti di attributi che potrebbero indicare aggiornamenti carrello
        if (mutation.type === 'attributes') {
          if (mutation.target.matches &&
              (mutation.target.matches('[data-cart-count]') || 
               mutation.target.classList.contains('cart-count'))) {
            shouldUpdate = true;
          }
        }
      });
      
      if (shouldUpdate) {
        setTimeout(updateCartCount, 500);
      }
    });
    
    observer.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['data-cart-count', 'class', 'data-item-count']
    });
  }

  // Inizializza i listener per il carrello
  setupCartListeners();

  // Inizializza i badge del carrello se non esistono
  setTimeout(() => {
    const existingBadges = document.querySelectorAll('.cart-count');
    if (existingBadges.length === 0) {
      createCartBadges(0);
    }
  }, 1000);
});